function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function buildGetAdvertisersQueryString({
  top = 12,
  skip = 0,
  searchText = '',
}) {
  const params = new URLSearchParams({
    top,
    skip,
    searchText,
  });

  return params.toString();
}

const convertPercentageToNumber = (percentage) => {
  const percentageNumber = Number(percentage.replace('%', ''));
  return percentageNumber;
};

function buildGetAdsQueryString({
  top = 12,
  skip = 0,
  startDate = '',
  endDate = '',
  countryCodeList = [],
  advertiserId = '',
  searchText = '',
}) {
  const params = new URLSearchParams();

  params.append('top', top);
  params.append('skip', skip);

  if (startDate) {
    params.append('startDate', `'${startDate}'`);
  }

  if (endDate) {
    params.append('endDate', `'${endDate}'`);
  }

  if (countryCodeList.length > 0) {
    params.append('countryCodes', `'${countryCodeList.join(',')}'`);
  }

  if (advertiserId) {
    params.append('advertiserId', advertiserId);
  }

  if (searchText) {
    params.append('searchText', searchText);
  }

  return params.toString();
}

export {
  capitalizeFirstLetter,
  convertPercentageToNumber,
  buildGetAdvertisersQueryString,
  buildGetAdsQueryString,
};
